import React from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../../Layout/BRSRSidebar";
import Principle9 from "./Principle9.jsx";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <Principle9 />
    </MainDashboardLayout>
  );
};

export default index;
